import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TManagerExternalOfficesIndexPayload,
  TManagerPaginatedExternalOffices,
} from '~/modules/manager/types';

export class ExternalOfficeModel extends ManagerResource {
  index(
    companyId: string | number,
    payload: TManagerExternalOfficesIndexPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TManagerPaginatedExternalOffices> {
    return this.get<TManagerPaginatedExternalOffices>(
      `companies/${companyId}/external-offices`,
      payload,
      requestConfig
    );
  }

  sync(officeId: string | number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync`, {}, requestConfig);
  }

  syncProperties(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-properties`, {}, requestConfig);
  }

  syncContacts(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-contacts`, {}, requestConfig);
  }

  syncNegotiators(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-negotiators`, {}, requestConfig);
  }

  syncVendorContacts(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-vendor-contacts`, {}, requestConfig);
  }

  syncLandlords(
    officeId: string | number,
    payload: { clean: boolean },
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-landlords`, payload, requestConfig);
  }

  syncApplicants(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-applicants`, {}, requestConfig);
  }

  syncOnlyProperties(
    officeId: string | number,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post<void>(`external-offices/${officeId}/sync-only-properties`, {}, requestConfig);
  }
}
